import concat from 'lodash/concat';
import size from 'lodash/size';
import uniq from 'lodash/uniq';
import { mapGetters } from 'vuex';

import PetSpecies from '@/enums/PetSpecies';
import SpeciesTreatedType from '@/enums/SpeciesTreatedType';
import {
  forgetCookie,
  setCookie,
} from '@/helpers/cookies';

export default {
  computed: {
    ...mapGetters(['isClient']),
    ...mapGetters('pets', ['getPets']),
    ...mapGetters('petConcerns', ['getPetConcerns']),
    ...mapGetters('speciesTreated', ['getSpeciesTreated']),

    /**
     * If `pet.species` is used to set cookie 'v-search-species-treated',
     * input handling may contain a value from 2 sets of enums?
     * The request to 'POST /p/search/guided' will transform whichever
     * input to the request parameter's expected SpeciesTreatedType enum.
     */
    speciesTreatedValues() {
      return uniq(concat(
        PetSpecies.values(),
        size(this.getSpeciesTreated)
          ? this.getSpeciesTreated.map((speciesTreated) => speciesTreated.name)
          : SpeciesTreatedType.values(),
      ));
    },
  },

  methods: {
    async fetchPets() {
      if (this.isClient && !size(this.getPets)) {
        await this.$store.dispatch('pets/fetchPets');
      }
    },
    filterValidConcerns(inputs) {
      return inputs.filter(
        (input) => this.getPetConcerns.some((petConcern) => petConcern.value === input),
      );
    },
    filterValidSpecies(inputs) {
      return inputs.filter((value) => this.speciesTreatedValues.includes(value));
    },
    findPet(uuid) {
      return this.getPets.find((pet) => pet.uuid === uuid);
    },
    forgetSearchCookies() {
      [
        'v-search-concern',
        'v-search-pet',
        'v-search-species-treated',
      ].map(forgetCookie);
    },
    getConcernsFromCookie() {
      return this.filterValidConcerns(
        JSON.parse(this.$cookies.get('v-search-concern') || '[]'),
      );
    },
    getPetFromCookie() {
      const uuid = this.$cookies.get('v-search-pet');
      const pet = this.findPet(uuid);

      // Delete stale cookie for a removed pet or from a previous user on the same device.
      if (uuid && !pet) {
        forgetCookie('v-search-pet');
      }

      return pet;
    },
    setConcernsCookie(concerns) {
      setCookie('v-search-concern', JSON.stringify(concerns), '1h');
    },
    setPetCookie(pet) {
      setCookie('v-search-pet', pet.uuid, '1h');
    },
    setSpeciesTreatedCookie(species) {
      const speciesTreated = this.filterValidSpecies(Array.isArray(species) ? species : [species]);

      setCookie('v-search-species-treated', JSON.stringify(speciesTreated), '1h');

      return speciesTreated;
    },
  },
};
